import React from 'react';
import { Card, CardContent } from "../../ui/card";
import { cn } from "../../../lib/utils";

interface ProjectCardProps {
  project: any; // replace with proper type later
  percentComplete: number;
  onClick?: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, percentComplete, onClick }) => {
  const percentClass = percentComplete >= 70 ? 'text-green-600' : percentComplete >= 40 ? 'text-orange-500' : 'text-red-500';

  return (
    <Card onClick={onClick} className={cn('cursor-pointer hover:ring-1 hover:ring-primary project-card')}>
      <CardContent className="p-4 flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-sm line-clamp-2 flex-1 min-w-0">{project.title}</h3>
          {project.due_date && (
            <span className="text-xs text-muted-foreground whitespace-nowrap">{new Date(project.due_date).toLocaleDateString()}</span>
          )}
        </div>
        {project.description && <p className="text-xs text-muted-foreground line-clamp-3">{project.description}</p>}
        <div className="flex items-center justify-between text-xs mt-auto pt-2 border-t border-muted">
          <span>{percentComplete}% complete</span>
          <span className={percentClass}>{project.status?.replace('_', ' ')}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectCard; 